<template>
<div class="session-detail-wrapper">
    <div v-if="loading">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Detail_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Detail_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="!loading && speaker">
        <!-- <h3 class="my-3 text-block mb-5">#SPEAKER</h3> -->
        <div class="d-flex flex-wrap" v-if="speaker && speaker._id">
            <!-- expert left side start-->
            <div class=" col-12 col-lg-4 col-xl-3 pl-0">
                <div class="d-flex d-lg-block">
                    <div class="col-12 p-0">
                        <div v-if="speaker && speaker.avatarSquareSmall && speaker.avatarSquareSmall.xxx" class="aligncenter col-12 col-4 col-lg-12 col-md-6 mb-4 p-0 sands-image-colored-overlay-hover">
                            <img :src="speaker.avatarSquareSmall.xxx" class="conference-shadow-rounded" alt="Manfred Steyer" width="500" height="350">
                            <!-- expert social start  -->
                            <div class="sands-speaker-info-inner gdlr-speaker-social gdlr-speaker-social-spleaker-detail old-layout mt-2">
                                <a target="_blank" v-if="speaker.facebook" class="gdlr-social-shortcode mx-2" :href="speaker.facebook"><img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/facebook.png" alt="facebook-icon"></a>
                                <a target="_blank" v-if="speaker.twitter" class="gdlr-social-shortcode mx-2" :href="speaker.twitter"><img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/twitter.png" alt="twitter-icon"></a>
                                <!-- <a target="_blank" v-if="expert.google" class="gdlr-social-shortcode" :href="expert.google"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/googleplus.png" alt="googleplus-icon"></a>
                        <a target="_blank" v-if="expert.linkedin" class="gdlr-social-shortcode" :href="expert.linkedin"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/linkedin.png" alt="linkedin-icon"></a> -->
                                <a target="_blank" v-if="speaker.blog" class="gdlr-social-shortcode mx-2" :href="speaker.blog"><img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/blog_Icon_v2.png" alt="blog-icon"></a>
                            </div>
                            <!-- expert social ENDS-->
                        </div>
                        <div v-if="widgetHtml" class="aligncenter call-for-action-box col-12 col-lg-12 col-md-6 old-layout p-0">
                            <span v-html="widgetHtml"></span>
                        </div>
                    </div>
                </div>

            </div>
            <!-- expert left side ends-->

            <!-- expert right side start-->
            <div class="col-12 col-lg-8 col-xl-9">
                <div class="rounded-l expert-box-padding">
                    <h1 v-if="speaker.forename && speaker.surname" class="gdlr-speaker-biography-title h3 font-weight-bold">{{speaker.forename}} {{speaker.surname}}</h1>
                    <p v-if="speaker && speaker.company" class="gdlr-speaker-position mb-3 text-black-50 font-weight-bolder">{{speaker.company}}</p>
                    <div v-if="speaker.bioEn" v-html="speaker.bioEn" class="gdlr-speaker-content"></div>
                    <div v-else-if="speaker.bio" v-html="speaker.bio" class="gdlr-speaker-content"></div>
                </div>
               <!--  <hr class="mt-2"> -->
                <div class="mt-3 rounded-l expert-box-padding">
                    <h4 v-if="speaker.forename && speaker.surname && speaker.sessions && speaker.sessions.length" class='single-speaker gdlr-speaker-session-title  mb-3 font-weight-bold'>All talks by {{speaker.forename}} {{speaker.surname}}</h4>

                    <div v-if="speaker.sessions && speaker.sessions.length">
                        <div v-for="(session, index) in speaker.sessions" :key="index">
                            <div v-if="session.name && session.slugNames && session.slugNames.length" class="py-1">
                                <router-link v-if="session.name && session.slugNames && session.slugNames.length" :to="`/session/${session.slugNames[0]}`">{{session.name}}</router-link>
                            </div>
                            <div v-else-if="session.name">
                                <p>{{session.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- expert right side ends-->

        </div>

    </div>
</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'
import {
    useRoute
} from 'vue-router'
export default {
    name: 'expertDetail',
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            loading: true,
            speaker: false,
            widgetHtml: false
        };
    },
    setup() {
        const route = useRoute();
        return route;
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    created() {
        this.emitter.emit('tracksRelatedSessions', false);
        if (this.settingsPerm && this.settingsPerm.callToAction) {
            this.widgetHtml = this.settingsPerm.callToAction;
        }
        const cache = new InMemoryCache();
        const apolloClient = new ApolloClient({
            cache,
            uri: this.settingsPerm.concordBackendURL,
        })
        provideApolloClient(apolloClient)
        let variablesForQuery = {
            slug: this.$route.params.slug,
            conferenceBrandId: this.settingsPerm.brandId,
        };
        const {
            result
        } = useQuery(CONCORD_QUERIES.EXPERT_BY_SLUG_QUERY, variablesForQuery, {
            fetchPolicy: 'cache-first',
        });
        watch(result, value => {
            if (value && value.vueExpert && value.vueExpert.Expert && value.vueExpert.Expert._id) {
                this.speaker = value.vueExpert.Expert;
                this.emitter.emit('infoFromChild', {'isSpeakerDetail':true,'expertName':this.speaker.forename + " " + this.speaker.surname, 'expertCompany':this.speaker.company});
                this.loading = false;
               
                let meta = {
                    "title": this.speaker.forename + " " + this.speaker.surname,
                    "description": this.speaker.bio,
                    "robots": "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
                    "canonical": window.location.href,
                    "og:locale": "en_GB",
                    "og:type": "Expert",
                    "og:title": this.speaker.forename + " " + this.speaker.surname,
                    "og:description": this.speaker.bio,
                    "og:url": window.location.href,
                }
                if (document.querySelector("[name='title']")) {
                    document.querySelector("[name='title']").remove();
                }
                if (document.querySelector("[name='description']")) {
                    document.querySelector("[name='description']").remove();
                }
                if (document.querySelector("[name='robots']")) {
                    document.querySelector("[name='robots']").remove();
                }
                if (document.querySelector("[name='og:type']")) {
                    document.querySelector("[name='og:type']").remove();
                }
                if (document.querySelector("[name='og:title']")) {
                    document.querySelector("[name='og:title']").remove();
                }
                if (document.querySelector("[name='og:description']")) {
                    document.querySelector("[name='og:description']").remove();
                }
                if (document.querySelector("[name='og:url']")) {
                    document.querySelector("[name='og:url']").remove();
                }

                let metaArry = Object.keys(meta);
                metaArry.forEach(key => {
                    var metaTag = document.createElement('meta');
                    metaTag.setAttribute('name', key);
                    metaTag.setAttribute('content', meta[key]);
                    document.getElementsByTagName('head')[0].appendChild(metaTag)
                });
            } else {
                this.loading = false;
            }
        })
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.gdlr-speaker-item-title {
    font-size: 15px;
    text-transform: none;
    font-weight: bold;
    letter-spacing: 2px;
    margin-bottom: 7px;
}
.gdlr-speaker-social img {
    height: 25px;
}

.gdlr-speaker-social:not(:first-of-type) {
    margin-left: 5px;
}
.rounded-l {
    box-shadow: 5px 5px 20px rgb(0 0 0 / 10%) !important;
    border-radius: 5px !important;
}
.expert-box-padding{
    padding: 10px 20px 10px 17px
}
</style>
